import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../redux';

import { Typography } from '@mui/material';
import {
  Loader,
  MainLayout,
  PageWrapper,
  Panel,
  ResponsiveBreak,
  StepPanel,
} from 'src/components';
import LetsConnect from '../../features/letsConnect/LetsConnect';

import {
  postUnsubscribeFromReminders,
  unsubscribeFromRemindersSelectors,
} from '../../redux/unsubscribeFromReminders';

import { isStatusComplete, isStatusLoading } from 'src/utils';

const UnsubscribeFromReminders = () => {
  const dispatch = useAppDispatch();
  const unsubscribeApiStatus = useAppSelector(
    unsubscribeFromRemindersSelectors.getUnsubscribeFromRemindersApiStatus,
  );
  const unsubscribeData = useAppSelector(
    unsubscribeFromRemindersSelectors.getUnsubscribeFromRemindersData,
  );

  const isLoading = isStatusLoading(unsubscribeApiStatus);
  const isSubmitted = isStatusComplete(unsubscribeApiStatus);

  useEffect(() => {
    if (unsubscribeData?.unsubscribeToken) {
      dispatch(
        postUnsubscribeFromReminders({
          user_email: unsubscribeData!.user_email,
          unsubscribeToken: unsubscribeData!.unsubscribeToken,
          unsubscribeType: unsubscribeData!.unsubscribeType,
        }),
      );
    }
  }, [unsubscribeData?.unsubscribeToken]);

  return (
    <PageWrapper>
      <MainLayout
        bgcolor={{
          xs: 'background.default',
          md: 'background.backgroundPrimary',
        }}
        data-testid="unsubscribe-from-layout"
      >
        {isLoading && <Loader />}
        {isSubmitted && (
          <StepPanel
            maxWidth="32.5rem"
            bgcolor={{ md: 'background.default' }}
            alignItems="flex-start"
            textAlign="left"
            py={{ md: 6 }}
            px={{ md: 6 }}
            sx={{
              transform: {
                lg: 'translateX(-15%)',
                xl: 'translateX(-30%)',
                xxl: 'translateX(-28%)',
              },
            }}
          >
            <Typography variant="h4" fontWeight="600">
              Sorry to hear you’re
              <ResponsiveBreak breakpoint={'md'} /> no longer interested,{' '}
              {unsubscribeData?.user_name}
            </Typography>

            <Typography variant="body1">
              You will not receive any more emails about your current job
              application, but we’re still open to staying in touch.
            </Typography>

            <LetsConnect withHeader={false} />

            <Panel>
              <Typography>
                You’ve unsubscribed from receiving job application updates.
              </Typography>
            </Panel>
          </StepPanel>
        )}
      </MainLayout>
    </PageWrapper>
  );
};

export default UnsubscribeFromReminders;
